require('./_signComponent.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const { Component } = require('react');
// @ components
const { Header } = require('components/header/header');
import { FormattedText, formatText } from 'core/i18n';

const MessagesScreen = require('components/messagesScreen/messagesScreen');
// @ actions
const preLoaderActions = require('actions/preLoaderActions');
// @ constants
const { PUBLICA_URL } = require('constants/index');
const SIGN_COMPLETE = 'signing_complete';
const ENVELOPE_ALREDY_SIGN = 'envelope_already_sign';
// @ utilities
const classNames = require('classnames');

class SignComponent extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { preLoaderActions } = this.props;

        preLoaderActions.hidePreLoader();
    }

    singContent() {
        const urlQueryParams = new URLSearchParams(this.props.location.search);
        let title;
        let contentValue;

        switch (urlQueryParams.get('event')) {
            case SIGN_COMPLETE:
                title = formatText('signingPage-docusignTitleComplete');
                contentValue = 'signingPage-docusignContentComplete';
                break;
            case ENVELOPE_ALREDY_SIGN:
                title = formatText('signingPage-docusignTitleOnProcess');
                contentValue = 'signingPage-docusignContentOnProcess';
                break;
            default:
                title = formatText('signingPage-docusignTitleCancel');
                contentValue = 'signingPage-docusignContentCancel';
        }

        return {
            title,
            contentValue,
        };
    }

    render() {
        const { action, buttonText, buttonClass, location } = this.props;
        const urlQueryParams = new URLSearchParams(location.search);
        const event = urlQueryParams.get('event');
        const { title, contentValue } = this.singContent();
        const iconClass = classNames({
            'icons icons--icon-success-blue': event === SIGN_COMPLETE,
            'icons icons--icon-docusing-on-process': event === ENVELOPE_ALREDY_SIGN,
            'icons icons--icon-warning': event !== SIGN_COMPLETE && event !== SIGN_COMPLETE,
        });

        return (
            <div>
                <Header hiddenContinueProcess={true} />
                <div className="main-container messages-main-container basic-layering">
                    <MessagesScreen
                        iconClass={iconClass}
                        title={title}
                        buttonText={buttonText}
                        buttonClass={buttonClass}
                        action={action}
                    >
                        <FormattedText value={contentValue} />
                        <hr />
                        <FormattedText value={'standByHC-footer'} />
                    </MessagesScreen>
                </div>
            </div>
        );
    }
}

SignComponent.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    content: PropTypes.string,
    iconClass: PropTypes.string,
    action: PropTypes.func,
    buttonText: PropTypes.string,
    buttonClass: PropTypes.string,
};

SignComponent.defaultProps = {
    action: () => {
        window.location.href = PUBLICA_URL;
    },
    buttonText: formatText('button-understood'),
    buttonClass: 'form__button form__button-secondary',
};

module.exports.constructor = SignComponent;
module.exports.SignComponent = connect(
    state => ({
        userProfile: state.userProfile,
    }),
    dispatch => ({
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(SignComponent);
